/**
 *
 * @howToUse Used in mui styled function to skip forwarding props to DOM
 * @example
 * ```ts
 * const StyledTab = styled(Tab, {
 *   shouldForwardProp: skipForwardProp(["isSelected"]),
 * }) ...
 * ```
 */
export const skipForwardProp = (propsArr: string[]) => {
  return (propName: PropertyKey) => !propsArr.includes(propName.toString());
};
